import ReactGA from 'react-ga';

/*
 * Initializes our google analytics with specified tracking id.
 */
const initializeAnalytics = (trackingId: string) => {
  ReactGA.initialize(trackingId);
};

/*
 * Sends page view analytics based on path and search terms.
 */
const sendPageViewAnalytics = (pathname: string, search: string) => {
  ReactGA.pageview(pathname + search);
};

/*
 * Sends event analytics.
 */
const sendEventAnalytics = (
  category: string,
  action: string,
  label?: string,
  value?: number,
  nonInteraction?: boolean,
) => {
  ReactGA.event({
    category,
    action,
    label,
    value,
    nonInteraction,
  });
};

/*
 * Sends event analytics from search query based on search
 * terms and filters.
 */
const sendSearchEventAnalytics = (query: any) => {
  let filters = '';
  let search = '';

  /*
   * Iterates through the key, values in our query object
   * and constructs the corresponding string label.
   */
  Object.entries(query).forEach((entry) => {
    const [key, value] = entry;
    if (value && key !== 'limit' && key !== 'offset') {
      if (key === 'q') {
        search = value as string;
      } else {
        filters += `${key}: ${value}; `;
      }
    }
  });

  /*
   * If the label is not empty, sends the analytics to google.
   */
  if (filters) {
    sendEventAnalytics('View All Events', 'Filter', filters.slice(0, -2));
  }

  if (search) {
    sendEventAnalytics('View All Events', 'Search', search);
  }
};

export {
  initializeAnalytics,
  sendPageViewAnalytics,
  sendEventAnalytics,
  sendSearchEventAnalytics,
};
